
  import React from "react"
  import Component from "F:/Websites/dhruv-kumar-jha/src/layouts/index.js"
  import data from "F:\\Websites\\dhruv-kumar-jha\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js